import { apiCall } from "./data";

export const loginUser = async (data) => {
    return apiCall("api/user/login", "POST", data);
};

export const signupUser = async (data) => {
    return apiCall("api/user/register", "POST", data);
};


export const sendForgotPasswordOtp = async (data) => {
    return apiCall("api/user/forgot-password/OTP-send", "POST", data);
};

export const resetPassword = async (data) => {
    return apiCall("api/user/forgot-password/OTP-verify", "POST", data);
};
